// extracted by mini-css-extract-plugin
module.exports = {"page_pdf":"styles_page_pdf__2KOU1"};